// BLOCKS
// ===================================================

var blocks = {

    settings: {
        logo_slider: $('.block-logo-slider'),
        review_slider: $('.block-review-slider'),
    },

    init: function() {
        // Logo Slider
        if (this.settings.logo_slider.length) {
            this.logoSlider();
        }
        // Review Slider
        if (this.settings.review_slider.length) {
            this.reviewSlider();
        }
    },

    // Logo Slider
    logoSlider: function() {

        blocks.settings.logo_slider.each(function() {

            var swiper = new Swiper($(this).find('.swiper')[0], {
                loop: true,
                navigation: {
                    nextEl: '.swiper-arrow.next',
                    prevEl: '.swiper-arrow.prev',
                },
                slidesPerView: 2,
                spaceBetween: 35,
                speed: 500,
                breakpoints: {
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                    960: {
                        slidesPerView: 4,
                        spaceBetween: 70,
                    },
                    1280: {
                        slidesPerView: 5,
                        spaceBetween: 70,
                    },
                },
            });

        });

    },

    // Review Slider
    reviewSlider: function() {

        blocks.settings.review_slider.each(function() {

            var swiper = new Swiper($(this).find('.swiper')[0], {
                loop: true,
                navigation: {
                    nextEl: '.swiper-arrow.next',
                    prevEl: '.swiper-arrow.prev',
                },
                pagination: {
                    clickable: false,
                    el: '.swiper-dots',
                },
                slidesPerView: 1,
                spaceBetween: 35,
                speed: 500,
            });

        });

    },

};
blocks.init();